$(document).ready(function(){
	$('.hero-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		dots: true,
		arrows: false,
		customPaging: function(slider, i) {
      // this example would render "tabs" with titles
      return '<span class="dot"></span>';
    }
	});

	$(".prev-btn.hero").click(function () {
		$(".hero-slider").slick("slickPrev");
	});

	$(".next-btn.hero").click(function () {
		$(".hero-slider").slick("slickNext");
	});


	$('.product-slider').slick({
		slidesToShow: 4.5,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		responsive: [
			{
				breakpoint: 1026,
				settings: {
						slidesToShow: 3.5,
						slidesToScroll: 1,
				}
			},
			{
				breakpoint: 770,
				settings: {
						slidesToShow: 2.5,
						slidesToScroll: 1,
				}
			},
			{
					breakpoint: 527,
					settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
					}
			},
		]
	});

	$(".prev-btn.product").click(function () {
		$(".product-slider").slick("slickPrev");
	});

	$(".next-btn.product").click(function () {
		$(".product-slider").slick("slickNext");
	});

	$('.testimonial-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		dots: true,
		arrows: false,
		customPaging: function(slider, i) {
      // this example would render "tabs" with titles
      return '<span class="dot"></span>';
    },
		responsive: [
			{
					breakpoint: 525,
					settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
					}
			},
			{
				breakpoint: 1050,
				settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
				}
			},
		]
	});

	$(".prev-btn.testimonial").click(function () {
		$(".testimonial-slider").slick("slickPrev");
	});

	$(".next-btn.testimonial").click(function () {
		$(".testimonial-slider").slick("slickNext");
	});
});